import { render, staticRenderFns } from "./WorkflowNode.vue?vue&type=template&id=9c1ed636&scoped=true"
import script from "./WorkflowNode.vue?vue&type=script&lang=js"
export * from "./WorkflowNode.vue?vue&type=script&lang=js"
import style0 from "./WorkflowNode.vue?vue&type=style&index=0&id=9c1ed636&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c1ed636",
  null
  
)

export default component.exports